var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('b-alert',{attrs:{"show":_vm.show,"dismissible":"","variant":_vm.type},on:{"dismissed":_vm.closeAlert}},[_c('i',{class:`mdi ${_vm.icon} mr-2`}),_vm._v(_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }